import { Navigate } from "react-router";
import { DashboardHeader } from "../../modules/dashboard/components/dashboard-header";
import { Page } from "../../modules/layout/components/page";
import { PageContent } from "../../modules/layout/components/page-content";
import { useFlags } from "../../server/optimizely";

import type { FC } from "react";

const DashboardPage: FC = () => {
  const {
    flags: { cha_4551_dashboard_2026 },
    flagsLoaded,
  } = useFlags("cha_4551_dashboard_2026");

  if (!flagsLoaded) return null;
  if (!cha_4551_dashboard_2026) return <Navigate replace to="/" />;

  return (
    <Page title="Home | ChangeEngine">
      <PageContent maxWidth="lg" mt={4}>
        <DashboardHeader />
      </PageContent>
    </Page>
  );
};

export default DashboardPage;
